// Microsoft Clarity — consent-gesteuertes Laden.
//
// Kanonische Projekt-ID: sd6rvwntt6 — dieselbe ID wie im Consent-Gate in
// index.html. Das Gate laedt Clarity beim Seitenaufruf, wenn die Einwilligung
// schon vorliegt. loadClarity() deckt den Fall ab, dass die Einwilligung erst
// waehrend dieser Sitzung erteilt wird (Klick im Cookie-Banner), und schuetzt
// per Script-Pruefung gegen einen Doppel-Load neben dem Gate.

const CLARITY_ID = "sd6rvwntt6";

const clarityScriptPresent = () =>
  !!document.querySelector('script[src*="clarity.ms"]');

const consentAccepted = () => {
  try {
    return localStorage.getItem("cookieConsent") === "accepted";
  } catch (e) {
    return false; // localStorage blockiert (Privatmodus) -> fail closed
  }
};

export const loadClarity = () => {
  if (typeof window === "undefined") return;
  if (!consentAccepted()) return;
  if (clarityScriptPresent()) return; // Gate hat bereits geladen

  window.clarity =
    window.clarity ||
    function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://www.clarity.ms/tag/" + CLARITY_ID;
  document.head.appendChild(script);
};

export const stopClarity = () => {
  if (typeof window === "undefined") return;

  if (window.clarity) {
    window.clarity("stop");
  }
};

export const hasClarityConsent = () => {
  if (typeof window === "undefined") return false;
  return consentAccepted();
};
